import { useEffect } from "react";
import { useContentSetting } from "../../Hooks/ContentSetting";
import { assetUrl } from "../../utils/galleryUtils";

const DEFAULT_TITLE = "Portal";

const BLANK_FAVICON =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'/%3E";

/**
 * Applies associate portal_setting (meta title, description, favicon) to the document.
 * Branding data is loaded via member_init (portal_setting on the affiliate school).
 */
export default function PortalBranding() {
  const { userInfo } = useContentSetting();
  const ps = userInfo?.portal_setting;

  useEffect(() => {
    const title =
      (ps?.meta_title && String(ps.meta_title).trim()) ||
      (ps?.brand_name && String(ps.brand_name).trim()) ||
      DEFAULT_TITLE;
    document.title = title;

    const desc = ps?.meta_decription;
    if (typeof desc === "string" && desc.trim()) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        metaDesc.setAttribute("name", "description");
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute("content", desc.trim());
    }

    const faviconPath =
      (ps?.favicon && String(ps.favicon).trim()) ||
      (ps?.brand_logo && String(ps.brand_logo).trim()) ||
      "";
    const faviconHref = faviconPath ? assetUrl(faviconPath) || BLANK_FAVICON : BLANK_FAVICON;

    const setLink = (rel, href) => {
      let link = document.querySelector(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement("link");
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.href = href;
    };

    setLink("icon", faviconHref);
    setLink("apple-touch-icon", faviconHref);
  }, [
    ps?.meta_title,
    ps?.brand_name,
    ps?.meta_decription,
    ps?.favicon,
    ps?.brand_logo,
  ]);

  return null;
}
